export default {
  LOGS: "Logs",
};
